export default __webpack_public_path__ + "static/media/5.b51c75ae.png";